import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import { Pagination } from '../../../../components/Pagination'
import { State } from '../../../../reducers'
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton'
import '../../styles/bitacora.style.css';

const TableBitacora = () => {
  const { dataBitacora } = useSelector((state: State) => state.bitacora);
  const [currentItems, setCurrentItems] = useState<Array<any>>([]);
  const [sortedArray, setSortedArray] = useState<Array<any>>([]);

  useEffect(() => {
    setSortedArray(currentItems);
  }, [currentItems]);

  const renderEstado = (itemCorreo: any) => {
    const { estadodescripcion } = itemCorreo;
    let formatTexto = estadodescripcion.charAt(0) + estadodescripcion.slice(1).toLowerCase();
    if (estadodescripcion === "EXITOSO") {
      return <div className='estado-correo documento-exitoso'>{formatTexto}</div>
    }
    else {
      return <div className='estado-correo documento-correo-invalido'>{formatTexto}</div>
    } 
  }

  return (
    <>
      {(dataBitacora?.length > 0) 
      && 
      (
        <div style={{overflowX: "scroll", width: '100%'}}>
          <div className="tab-plane">
            <div className="table-facturacion-resp">
                <table className="table-main-responsive responsive-table-main td-left table-pointer">
                    <thead>
                        <tr>
                            <td>No. <FilterButton keyName='numcorrelativo' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                            <td>DTE <FilterButton keyName='dte' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                            <td>Documento del cliente <FilterButton keyName='doccliente' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                            <td>Fecha de envío <FilterButton keyName='fechaenvio' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                            <td>Destinatario <FilterButton keyName='destinatario' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                            <td>Estado <FilterButton keyName='estado' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                        </tr>
                    </thead>
                    <tbody>
                      {
                        sortedArray?.length > 0 && 
                        (
                          sortedArray.map((item: any) => (
                            <tr key={item.numcorrelativo}>
                              <td data-label="No.">{item.numcorrelativo}</td>
                              <td data-label="DTE">{item.dte}</td>
                              <td data-label="Documento del cliente">{item.doccliente}</td>
                              <td data-label="Fecha de envío">{item.fechaenvio}</td>
                              <td data-label="Destinatario">{item.destinatario}</td>
                              <td data-label="Estado">{renderEstado(item)}</td>
                            </tr>
                          ))
                        )
                      }
                    </tbody>
                </table>
            </div>
            <Pagination
              data={dataBitacora}
              state={(items: Array<any>) => setCurrentItems(items)}
              items={20}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default TableBitacora
